<template>
    <article id="content-modules">
        <template>
            <template v-for="component in getModules">
                <component v-if="LazyLoad && supported()" :is="component.ClassName" :component="component" v-observe-visibility="{
                    callback: (isVisible, entry) => initiate(isVisible, entry, component.ID),
                    intersection: {rootMargin: '720px'},
                    once: true,
                    throttle: 100
                }"/>
                <component v-else :is="component.ClassName" :component="component" :class="fetchModuleData(component.ID)"/>
            </template>
        </template>
    </article>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {scroller} from 'vue-scrollto/src/scrollTo';

    export default {
        name: 'Modules',
        data() {
            return {
                'LazyLoad': false
            }
        },
        computed: {
            ...mapGetters(['getModules'])
        },
        methods: {
            ...mapActions(['fetchModules', 'fetchModuleData']),
            initiate(isVisible, entry, ID) {
                if (isVisible) {
                    this.fetchModuleData(ID);
                }
            },
            supported() {
                return 'IntersectionObserver' in window;
            }
        },
        created() {
            this.fetchModules();
            if ($(this.$parent.$el).data('disable-lazy')) {
                this.LazyLoad = false;
            }

            const modules = require.context("./modules", false, /[A-Z]\w+\.(vue|js)$/);
            modules.keys().forEach(fileName => {
                const componentName = fileName.split("/").pop().split(".")[0];
                const componentConfig = modules(fileName);
                this.$options.components[componentName] = componentConfig.default;
            });
        },
        mounted() {
            // anchoring workaround requires lazy load to be disabled
            // const anchorScroller = scroller();
            // setTimeout(() => {
            //     let hash = window.location.hash.substr(1);
            //     if (hash != '' && $('#' + hash).length) {
            //         anchorScroller('#' + hash);
            //     }
            // }, 2000);
        }
    };
</script>
